export default __webpack_public_path__ + "static/media/profile.3c747003.png";